import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";

function CertificatePage() {
  const [certInfo, setCertInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const isLoggedIn = !!sessionStorage.getItem("sessionId");

  useEffect(() => {
    fetch("/api/v1/version/certificate/ca/info", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        setCertInfo(data.data || data);
        setLoading(false);
      })
      .catch(() => {
        setCertInfo({ available: false });
        setLoading(false);
      });
  }, []);

  const handleDownload = () => {
    setDownloading(true);
    const link = document.createElement("a");
    link.href = "/api/v1/version/certificate/ca/download";
    link.download = "virtuoso-ca.pem";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      setDownloading(false);
      setDownloaded(true);
    }, 1000);
  };

  const renderCertStatus = () => {
    if (loading) {
      return (
        <p style={{ color: "#aaa", fontStyle: "italic", marginBottom: 20 }}>
          Loading certificate information...
        </p>
      );
    }

    if (!certInfo || !certInfo.available) {
      return (
        <div style={{ ...styles.badge.error, marginBottom: 20 }}>
          <i className="nc-icon nc-simple-remove" style={{ marginRight: 8 }} />
          Client Certificate not available on this server.
        </div>
      );
    }

    return null;
  };

  return (
    <div className="login-page">
      <Container>
        <Row>
          <Col md="8" className="loginInput">
            <Card className="card-login">
              <CardHeader>
                <h3 className="header text-center">
                  Client Certificate Installation
                </h3>
                <p
                  className="text-center"
                  style={{ color: "#888", marginTop: 4 }}
                >
                  Install the Client Certificate to remove the browser security
                  warning.
                </p>
              </CardHeader>

              <CardBody>{renderCertStatus()}</CardBody>

              <CardFooter>
                <Button
                  block
                  className="btn-round mb-3"
                  color={downloaded ? "success" : "info"}
                  onClick={handleDownload}
                  disabled={downloading || (certInfo && !certInfo.available)}
                >
                  {downloading
                    ? "Downloading..."
                    : downloaded
                    ? "✓ Downloaded"
                    : "Download Client Certificate"}
                </Button>

                <div style={{ textAlign: "center", marginTop: 8 }}>
                  <a
                    href={isLoggedIn ? "/admin/dashboard" : "/auth/login"}
                    style={{ color: "#51cbce", fontSize: 14 }}
                  >
                    {isLoggedIn ? "← Back to dashboard" : "← Back to login"}
                  </a>
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>

      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`,
        }}
      />
    </div>
  );
}

const styles = {
  badge: {
    error: {
      backgroundColor: "#FFC0A4",
      border: "1px solid #ef8157",
      color: "#66615b",
      padding: "10px 15px",
      borderRadius: 4,
    },
  },
};

export default CertificatePage;
